<template>
  <div v-drag id="scheme-drag-modal">
    <a-modal
      v-model:visible="modalConfig.visible"
      :title="modalConfig.title"
      @ok="handleOk"
      @cancel="closeModal"
      :force-render="true"
      :get-container="getContainer"
    >
      <a-form
        :model="formState"
        ref="formRef"
        :rules="rules"
        :labelCol="{
          span: 5,
        }"
      >
        <!-- <a-form-item label="wbs" name="wbs" v-if="isBaseData">
        <a-input
          v-model:value="formState.wbs"
          placeholder="请输入wbs"
        ></a-input>
      </a-form-item> -->
        <a-form-item label="任务名称" name="taskName" v-if="isBaseData">
          <a-input v-model:value="formState.taskName"></a-input>
        </a-form-item>

        <a-form-item label="关联" name="association" v-if="isBaseData">
          <a-select
            v-model:value="taskTypeValue"
            placeholder="关联类型"
            :options="taskTypeOptions"
            style="width: 300px"
            @change="handleSelectAssociation($event, 'taskType')"
            allowClear
          ></a-select>
          <a-select
            show-search
            placeholder="选择关联任务"
            style="width: 200px"
            :options="wbsOptions"
            v-model:value="wbsValue"
            allowClear
            @change="handleSelectAssociation($event, 'wbs')"
          >
          </a-select>
        </a-form-item>
        <!-- 输出成果 -->
        <a-form-item label="任务最终输出" v-if="isBaseData">
          <after-sale-qeustion-vue
            v-if="modalConfig.visible"
            :questionLists="formState.outputResults"
            noticeText="任务最终输出"
            ref="outputResultRef"
            textAreaStyle="'width: 300px; margin-right: 8px; height: auto'"
          >
          </after-sale-qeustion-vue>
        </a-form-item>
        <!-- 预计时间 -->
        <a-form-item label="发布时间" name="release" v-if="showRelease">
          <a-range-picker
            v-model:value="releaseRangeDate"
            placeholder="请选择发布时间"
            @change="handleRangeDate($event, 'release')"
          />
        </a-form-item>
        <!-- 计划时间 -->
        <a-form-item label="计划时间" name="scheduled" v-if="showScheduled">
          <a-range-picker
            v-model:value="scheduledRangeDate"
            placeholder="请选择计划时间"
            @change="handleRangeDate($event, 'scheduled')"
          />
        </a-form-item>
        <!-- 实际处理时间 -->
        <a-form-item label="实际开始日期" v-if="showActualRelease">
          <!-- <a-range-picker
          v-model:value="actualReleaseRangeDate"
          placeholder="请选择实际日期"
          @change="handleRangeDate($event, 'actualRelease')"
        /> -->
          <a-space>
            <a-date-picker
              v-model:value="formState.actualReleaseStartTime"
              placeholder="请选择实际开始日期"
            />
            <!-- <a-date-picker
            v-model:value="formState.actualReleaseEndTime"
            placeholder="请选择实际结束日期"
          /> -->
          </a-space>
        </a-form-item>
        <!-- 执行人 -->
        <a-form-item
          :label="executorLabelName"
          name="executor"
          v-if="showRelease"
        >
          <staff
            v-if="modalConfig.visible"
            :echoStaff="toRaw(formState).executorId"
            :echostaffUserName="toRaw(formState).executor"
            @getChooseStaff="getChooseStaff"
            style="width: 260px"
          ></staff>
        </a-form-item>

        <a-form-item label="完成率" v-if="showActualRelease">
          <a-input-number
            v-model:value="formState.completionDegree"
            :step="1"
            :formatter="(value) => `${value}%`"
            :parser="(value) => value.replace('%', '')"
            placeholder="请输入完成率"
          ></a-input-number>
        </a-form-item>
        <!-- 文件 -->
        <!-- <a-form-item label="文件" v-if="isBaseData || showActualRelease">
        <upload
          @setUploadFileUrl="setUploadFileUrl"
          :echoFile="formState.fileLink"
        ></upload>
      </a-form-item> -->
        <a-form-item label="工作记录" v-if="showActualRelease">
          <!-- <a-textarea
          v-model:value="formState.workRecords"
          auto-size
        ></a-textarea> -->
          <after-sale-qeustion-vue
            v-if="modalConfig.visible"
            :questionLists="formState.workRecords"
            noticeText="工作记录"
            ref="workRecordsRef"
            textAreaStyle="'width: 300px; margin-right: 8px; height: auto'"
          >
          </after-sale-qeustion-vue>
        </a-form-item>
        <a-form-item label="所需帮助" v-if="isBaseData">
          <a-textarea
            v-model:value="formState.assistanceNeeded"
            auto-size
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
   
<script>
import {
  computed,
  defineComponent,
  inject,
  nextTick,
  reactive,
  ref,
  toRaw,
} from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import {
  insertProjectSchedule,
  updateProjectSchedule,
} from "@/request/view/project";
import websocket from "@/utils/base/socket";
import { getStrctreStaff } from "@/utils/base/staff";
import { debounce, timeStampToTime, Toast } from "@/utils/index";
import upload from "@/views/rdmanagement/components/database/upload.vue";
import staff from "@/components/chooseStaff/staff.vue";
import afterSaleQeustionVue from "@/views/repair/components/afterSaleQeustion.vue";

export default defineComponent({
  components: { upload, staff, afterSaleQeustionVue },
  props: {
    projectLifeCycle: String,
  },
  directives: {
    drag: {
      mounted(el, binding) {
        nextTick(() => {
          const [modalArea] = Array.from(
            el.getElementsByClassName("ant-modal-wrap")
          );

          const [modalContent] = Array.from(
            el.getElementsByClassName("ant-modal-content")
          );

          if (!modalContent) return;

          const [modalHeader] = Array.from(
            el.getElementsByClassName("ant-modal-header")
          );

          if (!modalHeader) return;

          const [modalTitle] = Array.from(
            el.getElementsByClassName("ant-modal-title")
          );

          modalTitle.style.userSelect = "none";

          modalHeader.style.cursor = "grab";

          const origin = {
            x: 0,
            y: 0,
            minusX: 0,
            minusY: 0,
          };

          let mousedown = null;

          const setMove = (e) => {
            if (!mousedown || !e) return;

            const { clientX, clientY } = e;

            const moveX = clientX - (origin.x + origin.minusX);
            const moveY = clientY - origin.minusY;
            modalContent.style.left = `${moveX}px`;
            modalContent.style.top = `${moveY}px`;
          };

          modalHeader.addEventListener("mousedown", (e) => {
            if (origin.x === 0 && origin.y === 0) {
              const { x, y, width } = modalContent.getBoundingClientRect();
              modalContent.style.width = `${width}px`;
              origin.x = x;
              origin.y = y;

              origin.minusX = e.screenX - origin.x;
              origin.minusY = e.screenY - origin.y;
            }
            modalHeader.style.cursor = "move";
            mousedown = true;
          });

          modalHeader.addEventListener("mouseup", (e) => {
            modalHeader.style.cursor = "grab";
            mousedown = false;
          });

          modalArea.addEventListener("mousemove", (e) => {
            setMove(e);
          });
        });
      },
    },
  },
  setup(props, context) {
    const route = useRoute();
    const user = useStore().state.user.user;
    const wbsOptions = inject("wbsOptions", []);

    const outputResultRef = ref();
    const workRecordsRef = ref();
    // 模态框数据
    const modalConfig = reactive({
      visible: false,
      title: " ",
      isInsert: false,
      type: null,
      step: null,
    });

    const taskTypeValue = ref(null);
    const wbsValue = ref(null);

    const unUseNotice = ref(false);

    const taskTypeOptions = [
      // 关联任务开始，本项任务才能开始
      {
        label: "SS关联任务开始，本项任务才能开始",
        value: "SS",
      },
      // 关联任务结束，本项任务才能开始
      {
        label: "FS关联任务结束，本项任务才能开始",
        value: "FS",
      },
      // 关联任务开始，本项任务才能结束
      {
        label: "SF关联任务开始，本项任务才能结束",
        value: "SF",
      },
      // 关联任务结束，本项任务才能结束
      {
        label: "FF关联任务结束，本项任务才能结束",
        value: "FF",
      },
    ];

    const showRelease = computed(() => modalConfig.type === "release");

    const showScheduled = computed(() => modalConfig.type === "scheduled");

    const showActualRelease = computed(
      () => modalConfig.type === "actualRelease"
    );

    const executorLabelName = computed(() => {
      // if (showRelease.value) {
      //   return "计划人";
      // }
      // if (showScheduled.value) {
      //   return "执行人";
      // }
      // if (showActualRelease.value) {
      //   return "执行人";
      // }
      return "执行人";
    });

    //
    const isBaseData = computed(
      () =>
        modalConfig.type === "insertSubtask" ||
        modalConfig.type === "updateTask" ||
        modalConfig.type === "insertTask"
    );

    // 表单数据
    const formState = reactive({
      actualReleaseEndTime: null,
      actualReleaseStartTime: null,
      assistanceNeeded: null,
      association: null,
      associationId: null,
      completionDegree: null,
      executor: null,
      executorId: null,
      id: null,
      isOpen: null,
      outputResults: null,
      pid: 0,
      projectLifeCycle: null,
      projectLifeCycleId: null,
      publisher: null,
      releaseEndTime: null,
      releaseStartTime: null,
      scheduledEndTime: null,
      scheduledStartTime: null,
      structureName: null,
      taskName: null,
      toUsers: null,
      planner: null,
      plannerId: null,
      userId: null,
      username: null,
      wbs: null,
      workRecords: null,
    });

    const checkRangeTime = (startKey, endKey) => {
      if (formState[startKey] !== null && formState[endKey] !== null) {
        return Promise.resolve();
      }
      return Promise.reject("请选择时间");
    };

    const checkRelease = async () => {
      return checkRangeTime("releaseStartTime", "releaseEndTime");
    };

    const checkScheduled = async () => {
      return checkRangeTime("scheduledStartTime", "scheduledEndTime");
    };

    const checkActualRelease = async () => {
      return checkRangeTime("actualReleaseStartTime", "actualReleaseEndTime");
    };

    const checkExecutor = async () => {
      if (showRelease.value && formState.executor === null) {
        return Promise.reject("请选择计划人");
      } else if (showRelease.value && formState.executor) {
        return Promise.resolve();
      }
      if (showScheduled.value && formState.executor === null) {
        return Promise.reject("请选择执行人");
      } else if (showScheduled.value && formState.executor) {
        return Promise.resolve();
      }
      return Promise.resolve();
    };
    // 校验规则
    const rules = {
      // wbs: [
      //   {
      //     required: true,
      //     message: "请输入wbs",
      //     trigger: true,
      //     type: "any",
      //   },
      // ],
      taskName: [
        {
          required: true,
          message: "请输入任务名称",
          trigger: "blur",
          type: "any",
        },
      ],
      release: [
        {
          required: true,
          validator: checkRelease,
          trigger: "change",
        },
      ],
      scheduled: [
        {
          required: true,
          validator: checkScheduled,
          trigger: "change",
        },
      ],
      actualRelease: [
        {
          required: true,
          validator: checkActualRelease,
          trigger: "change",
        },
      ],
      executor: [
        {
          required: true,
          validator: checkExecutor,
          trigger: "change",
        },
      ],
    };
    // 表单
    const formRef = ref();

    const association = {
      wbs: null,
      taskType: null,
    };
    // 重置表单
    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      association.taskType = null;
      association.wbs = null;
      taskTypeValue.value = null;
      wbsValue.value = null;
      formRef.value.clearValidate();
    };
    const scoketNotice = (options) => {
      const { toUserId, text, taskName } = options;
      const query = Object.assign(
        {
          activeKey: "项目计划",
          type: "link",
        },
        route.query
      );
      query.taskName = taskName;
      if (user.id == toUserId) return;
      websocket.Send({
        content: text,
        query: JSON.stringify(query),
        route: "/rdprojectlayout",
        messageSort: "项目计划",
        toUserId: toUserId,
        type: 0,
        userId: user.id,
      });
    };

    // websocket通知
    const websocketNotice = () => {
      return new Promise((resolve, reject) => {
        if (unUseNotice.value) {
          resolve();
          return;
        }
        if (showScheduled.value) {
          resolve();
          return;
        }
        let toUserId = null;
        const { nickName } = user;
        const localTime = timeStampToTime("", "upload");

        const { projectName, projectLifeCycle } = route.query;
        let text = `${nickName}推送 ${projectName}项目 ${formState.taskName}任务`;
        let taskName = formState.taskName;
        if (showRelease.value) {
          getStrctreStaff(formState.executor)
            .then((res) => {
              toUserId = String(res.id).replace("P", "");
              scoketNotice({ text, toUserId, taskName });
              resolve();
            })
            .catch((err) => {
              console.log(err);
            });
        } else if (showScheduled.value) {
          getStrctreStaff(formState.executor).then((res) => {
            toUserId = String(res.id).replace("P", "");
            scoketNotice({ text, toUserId, taskName });
            resolve();
          });
        } else if (
          showActualRelease.value &&
          formState.completionDegree >= 100
        ) {
          text = `${formState.executor}已完成${formState.taskName}任务`;
          scoketNotice({ text, toUserId: formState.userId, taskName });
          // scoketNotice({ text, toUserId: formState.userId, taskName });
          resolve();
        }
        resolve();
      });
    };
    const getChooseStaff = (data) => {
      const { idList, staffUserName, structureName } = data;
      // formState.toUsers = staffUserName[0];
      // formState.structureName = structureName[0];

      // formState.executor = formState.toUsers;
      // formState.executorId = idList[0];
      // if (showRelease.value) {
      //   formState.planner = staffUserName[0];
      //   formState.plannerId = idList[0];
      // }
      if (showRelease.value) {
        formState.executor = staffUserName[0];
        formState.executorId = idList[0];
      }

      if (showScheduled.value) {
        formState.executor = staffUserName[0];
        formState.executorId = idList[0];
      }

      console.log(data, formState, '+++++++++++++');
    };

    // 设置
    const insertFormData = () => {
      const { projectId } = route.query;
      formState.projectLifeCycle = props.projectLifeCycle;
      formState.projectLifeCycleId = projectId;
    };

    // 时间范围值
    const releaseRangeDate = ref([]);
    const scheduledRangeDate = ref([]);
    const actualReleaseRangeDate = ref([]);

    const setRecordTime = (data) => {
      if (data.releaseStartTime && data.releaseEndTime) {
        releaseRangeDate.value.push(data.releaseStartTime, data.releaseEndTime);
      }

      if (data.scheduledStartTime && data.scheduledEndTime) {
        scheduledRangeDate.value.push(
          data.scheduledStartTime,
          data.scheduledEndTime
        );
      }

      if (data.actualReleaseStartTime && data.actualReleaseEndTime) {
        actualReleaseRangeDate.value.push(
          data.actualReleaseStartTime,
          data.actualReleaseEndTime
        );
      }
    };

    /**
     * 新增任务
     * */
    const insertTask = (data, record) => {
      formState.pid = 0;
    };

    /**
     * 新增子任务
     */
    const insertSubtask = (data, record) => {
      data.pid = record.id;
    };

    /**
     * 修改任务
     */
    const updateTask = (data, record) => {
      Object.keys(data).forEach((key) => {
        formState[key] = record[key];
      });
      setRecordTime(record);
    };

    const strategy = {
      insertTask,
      insertSubtask,
      updateTask,
      release: updateTask,
      scheduled: updateTask,
      actualRelease: updateTask,
    };

    // 打开表单
    const showModal = (options) => {
      if (!props.projectLifeCycle) {
        Toast("warning", "请选择项目阶段", 3);
        return;
      }
      modalConfig.visible = true;
      modalConfig.type = options.type;
      modalConfig.title = options.title;
      if (strategy[options.type]) {
        strategy[options.type](formState, options.data);
      }

      if (formState.association) {
        taskTypeValue.value = formState.association.slice(0, 2);
        wbsValue.value = formState.association.slice(2);
        association.taskType = formState.association.slice(0, 2);
        association.wbs = formState.association.slice(2);
      }

      if (formState.completionDegree == 100) {
        unUseNotice.value = true;
      }
    };
    // 关闭表单
    const closeModal = () => {
      releaseRangeDate.value.length = 0;
      scheduledRangeDate.value.length = 0;
      actualReleaseRangeDate.value.length = 0;
      taskTypeValue.value = null;
      wbsValue.value = null;
      modalConfig.visible = false;
      // modalConfig.title = "";
      modalConfig.isInsert = null;
      modalConfig.type = null;
      modalConfig.step = null;
      resetForm();
    };

    const getOutPutResult = (componentRef, key) => {
      if (!componentRef) return;
      const result = JSON.stringify(componentRef.questionList);
      if (result && result !== "[]") {
        const textData = JSON.parse(result);
        textData.forEach((item) => {
          delete item.disabled;
          delete item.key;
        });
        formState[key] = JSON.stringify(textData);
      }
    };

    // 提交表单
    const handleOk = debounce(() => {
      if (modalConfig.type !== "updateTask") insertFormData();
      getOutPutResult(outputResultRef.value, "outputResults");
      getOutPutResult(workRecordsRef.value, "workRecords");
      formRef.value
        .validate()
        .then(() => {
          let reqFn = null;
          if (
            modalConfig.type === "insertTask" ||
            modalConfig.type === "insertSubtask"
          ) {
            formState.structureName =
              user.secondaryDepartment || user.firstLevelDepartment;
            reqFn = insertProjectSchedule;
            formState.publisher = user.nickName;
            formState.userId = user.id;
            formState.username = user.nickName;
          } else {
            reqFn = updateProjectSchedule;
          }

          if (modalConfig.type === "actualRelease") {
            formState.isOpen = true;
          }

          if (
            modalConfig.type === "actualRelease" &&
            formState.completionDegree
          ) {
            formState.actualReleaseEndTime = timeStampToTime("", "upload");
          }

          reqFn(formState)
            .then(async (res) => {
              let type = res.code === 200 ? "success" : "warning";
              Toast(type, res.message, 3);

              // if (!isBaseData.value && res.message === "成功") {
              //   await websocketNotice();
              // }
              if (
                formState.executorId != user.id &&
                !isBaseData.value &&
                res.message === "成功"
              ) {
                await websocketNotice();
              }
              context.emit("updateTable");
              closeModal();
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }, 10);
    // 上传文件
    const setUploadFileUrl = (url) => {
      formState.fileLink = url;
    };

    // 选择时间范围
    const handleRangeDate = (date, type) => {
      const [sTime, eTime] = date;
      if (sTime === undefined) {
        formState[`${type}StartTime`] = null;
        formState[`${type}EndTime`] = null;
      } else {
        formState[`${type}StartTime`] = timeStampToTime(sTime._d, "upload");
        formState[`${type}EndTime`] = timeStampToTime(eTime._d, "upload");
      }
    };

    // 选择任务关联
    const handleSelectAssociation = (e, type) => {
      if (e === undefined) {
        formState.association = null;
        formState.associationId = null;
      }

      association[type] = e;
      if (association.wbs && association.taskType) {
        formState.association = `${association.taskType}${association.wbs}`;
        const record = wbsOptions.value.find(
          (item) => item.value === association.wbs
        );
        formState.associationId = record.id;
      }
    };

    const getContainer = () => {
      if (document && document.getElementById) {
        return document.getElementById("scheme-drag-modal");
      }
      return document.body;
    };

    return {
      toRaw,
      handleOk,
      showModal,
      closeModal,
      getChooseStaff,
      handleRangeDate,
      setUploadFileUrl,
      handleSelectAssociation,
      taskTypeOptions,
      outputResultRef,
      workRecordsRef,
      releaseRangeDate,
      wbsOptions,
      scheduledRangeDate,
      actualReleaseRangeDate,
      modalConfig,
      formState,
      formRef,
      rules,
      executorLabelName,
      isBaseData,
      showRelease,
      showScheduled,
      showActualRelease,
      taskTypeValue,
      wbsValue,
      getContainer,
    };
  },
});
</script>
   
<style lang="less" scoped>
</style>